<script>
  import { page } from '@inertiajs/svelte'

  // Props mirror Pagy metadata as returned by AdminSite::Paginatable#paginate.
  // `param` names the page query param (a page with two paged lists); `onpage`
  // replaces the full visit with the caller's own (e.g. a partial reload).
  let { page: currentPage, pages, count, param = 'page', onpage = null } = $props()

  const hrefFor = (targetPage) => {
    const url = new URL($page.url, 'http://placeholder')
    url.searchParams.set(param, targetPage)
    return `${url.pathname}${url.search}`
  }

  const go = (event, targetPage) => {
    if (!onpage) return
    event.preventDefault()
    if (targetPage !== currentPage) onpage(targetPage)
  }

  const windowPages = $derived.by(() => {
    const start = Math.max(1, currentPage - 2)
    const end = Math.min(pages, currentPage + 2)
    const result = []
    for (let i = start; i <= end; i++) result.push(i)
    return result
  })
</script>

{#if count > 0}
  <div class="flex items-center justify-between mt-4">
    <span class="text-sm text-base-content/60">
      {count.toLocaleString()} {count === 1 ? 'result' : 'results'}{#if pages > 1}&nbsp;· page {currentPage} of {pages}{/if}
    </span>

    {#if pages > 1}
    <div class="join">
      <a
        href={hrefFor(Math.max(1, currentPage - 1))}
        onclick={(event) => go(event, Math.max(1, currentPage - 1))}
        class="join-item btn btn-sm"
        class:btn-disabled={currentPage <= 1}
      >
        «
      </a>

      {#each windowPages as targetPage (targetPage)}
        <a
          href={hrefFor(targetPage)}
          onclick={(event) => go(event, targetPage)}
          class="join-item btn btn-sm"
          class:btn-primary={targetPage === currentPage}
          aria-current={targetPage === currentPage ? 'page' : undefined}
        >
          {targetPage}
        </a>
      {/each}

      <a
        href={hrefFor(Math.min(pages, currentPage + 1))}
        onclick={(event) => go(event, Math.min(pages, currentPage + 1))}
        class="join-item btn btn-sm"
        class:btn-disabled={currentPage >= pages}
      >
        »
      </a>
    </div>
    {/if}
  </div>
{/if}
